import {getElementIndexParams} from '../helpers/elementIndex.js';
import {useEnv} from '../helpers/env';

// Create the abort controller
let controller = null;

if (process.client) {
  controller = new AbortController();
}

const {apiEndpointUrl} = useEnv();

export default {
  cancelRequests() {
    if (process.client && controller) {
      // Abort requests
      controller.abort();

      // Create new abort controller
      controller = new AbortController();
    }
  },

  async getPluginsByCategory({categoryId, pluginIndexParams}) {
    const params = this._getPluginIndexParams(pluginIndexParams);
    params.categoryId = categoryId;

    try {
      const data = await $fetch('plugin-store/plugins', {
        baseURL: apiEndpointUrl,
        signal: controller ? controller.signal : undefined,
        params,
      });
      return {data};
    } catch (error) {
      if (error.name === 'AbortError') {
        // request cancelled
        return;
      }
      throw error;
    }
  },

  async getPluginsByDeveloperId({developerId, pluginIndexParams}) {
    const params = this._getPluginIndexParams(pluginIndexParams);
    params.developerId = developerId;

    try {
      const data = await $fetch('plugin-store/plugins', {
        baseURL: apiEndpointUrl,
        signal: controller ? controller.signal : undefined,
        params,
      });
      return {data};
    } catch (error) {
      if (error.name === 'AbortError') {
        // request cancelled
        return;
      }
      throw error;
    }
  },

  async getPluginsByFeaturedSectionHandle({
    featuredSectionHandle,
    pluginIndexParams,
  }) {
    const params = this._getPluginIndexParams(pluginIndexParams);

    try {
      const data = await $fetch(`plugin-store/plugins-by-featured-section/${featuredSectionHandle}`, {
        baseURL: apiEndpointUrl,
        signal: controller ? controller.signal : undefined,
        params,
      });
      return {data};
    } catch (error) {
      if (error.name === 'AbortError') {
        // request cancelled
        return;
      }
      throw error;
    }
  },

  _getPluginIndexParams({cmsConstraint, perPage, page, orderBy, direction}) {
    return {
      cmsConstraint,
      ...getElementIndexParams({perPage, page, orderBy, direction}),
    };
  },

  async searchPlugins({searchQuery, pluginIndexParams}) {
    const params = this._getPluginIndexParams(pluginIndexParams);
    params.searchQuery = searchQuery;

    try {
      const data = await $fetch('plugin-store/plugins', {
        baseURL: apiEndpointUrl,
        signal: controller ? controller.signal : undefined,
        params,
      });
      return {data};
    } catch (error) {
      if (error.name === 'AbortError') {
        // request cancelled
        return;
      }
      throw error;
    }
  },
};
